<template>
	<section class="logo">
        <div>
            <div class="logo-art">
                <img src="/gfx/logo.png" alt="">
            </div>
            <div class="logo-text">
                <h2>old school ⛧ new school ⛧ no school</h2>
            </div>
        </div>
	</section>
</template>

<script>
	export default {
		name: 'Logo'
	}
</script>